"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaErrorToJSON = exports.RosettaErrorFromJSONTyped = exports.RosettaErrorFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaErrorFromJSON(json) {
    return RosettaErrorFromJSONTyped(json, false);
}
exports.RosettaErrorFromJSON = RosettaErrorFromJSON;
function RosettaErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
        'message': json['message'],
        'retriable': json['retriable'],
        'details': !runtime_1.exists(json, 'details') ? undefined : _1.RosettaErrorDetailsFromJSON(json['details']),
    };
}
exports.RosettaErrorFromJSONTyped = RosettaErrorFromJSONTyped;
function RosettaErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
        'retriable': value.retriable,
        'details': _1.RosettaErrorDetailsToJSON(value.details),
    };
}
exports.RosettaErrorToJSON = RosettaErrorToJSON;
//# sourceMappingURL=RosettaError.js.map